// src/i18n.ts
import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './shared/locales/English/en';
import de from './shared/locales/German/de';
import es from './shared/locales/es';
import fr from './shared/locales/fr';
import it from './shared/locales/it';
import pt from './shared/locales/pt';
import zh from './shared/locales/zh';
import ja from './shared/locales/ja';
import ko from './shared/locales/ko';
import ru from './shared/locales/ru';
import tr from './shared/locales/tr';
import ar from './shared/locales/ar';
import hi from './shared/locales/hi';

const resources = {
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
  ru: { translation: ru },
  tr: { translation: tr },
  ar: { translation: ar },
  hi: { translation: hi },
} satisfies Resource;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    // ✅ IMPORTANT: remove `lng: 'en'`
    fallbackLng: 'en',

    detection: {
      // ✅ use your key
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'unyLanguage', // must store "en", "de", ...
    },

    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
  });

export default i18n;
